// File: assets/custom-recipe-kit.js (Reload and Open Method)

// Part 1: The event listener.
// This runs when an item is added from the Recipe Kit card.
document.addEventListener(
  "rk_cart_event",
  function (e) {
    console.log(
      "Recipe Kit Event: Setting flag and reloading page to show cart."
    );

    // Set a flag in the browser's session storage. This flag will
    // survive the page reload.
    sessionStorage.setItem("openCartAfterReload", "true");

    // Trigger the page reload.
    location.reload();
  },
  false
);

// Part 2: The page load checker.
// This runs on every page load to check for the flag.
document.addEventListener("DOMContentLoaded", function () {
  if (sessionStorage.getItem("openCartAfterReload") === "true") {
    console.log("Reload Flag Found: Opening cart drawer.");

    // Find the cart drawer element.
    const cartDrawer = document.querySelector("cart-drawer");

    // Open it if it exists and has an 'open' method.
    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
    }

    // IMPORTANT: Remove the flag so this doesn't run again on the next refresh.
    sessionStorage.removeItem("openCartAfterReload");
  }
});
